import { InjectionToken } from '../../injection';
import { ParameterValueType } from '../interfaces/dictionary.interface';

/** The string templating service interface. */
export interface IStringTemplateService {

  /** Compiles the template with the provided parameters.
   * Example:
   * template="Welcome to {{appName}}! How are you today {{userName}}?"
   * parameters={ appName: "Mobiz", userName: "Harald" };
   * Returns "Welcome to Mobiz! How are you today Harald?".
   * @param template The template. The item format need to have the fallowing format {{item}} inside the template.
   * @param parameters The parameters.
   */
  compile(template: string, parameters?: Record<string, ParameterValueType>): string;
}

export const IStringTemplateService = new InjectionToken('IStringTemplateService');
